var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.305 3.304a.75.75 0 0 1 .556 1.392l-3.514 1.407q-.496.196-1.014.278v2.07l3.22 5.151.037.068a.75.75 0 0 1-1.31.728l-2.697-4.316-2.697 4.316a.75.75 0 1 1-1.272-.796l3.219-5.15V6.381a4.8 4.8 0 0 1-1.014-.278L3.305 4.696a.75.75 0 0 1 .556-1.392l3.515 1.405c.775.31 1.64.31 2.414 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.583 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};
export default Svg16;